import React from 'react'
import Layout from '../components/Layout'

export default class IndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <section className="section">
          <div className="container">
            <div className="content">
              <h1 className="has-text-weight-bold is-size-2">Hi there. I'm <a href="https://twitter.com/eschapp">Eric</a>. I'm currently in the process of tying things I've done together with this page being the jumping off point.</h1>
              <h2>
                I've begun this process as of February 7th, 2019 (a nudge for myself). For now my order of operations are:
                <ol>
                  <li>Home page; move this list to a WIP page to live in seclusion. Or just not as a front page.</li>
                  <li>An About Page. Because people need to know that I used to play trumpet and thow javelin.</li>
                  <li>A Blog page. Everyone want to write moar better.</li>
                  <li>A 2019 Goal MDX-Slide Deck. My goal for 2019 is complete a race each month which is probably a good fit for this.</li>
                  <li>Roll in some live examples (react, vue, et cetra). Most probably embarrassing; can't use a lot of work product.</li>
                  <li>Some interest pages that live on 3rd party services at the moment. Books, State/National Parks Visited? Maybe.</li>
                  <li>...TBD</li>
                </ol>
              And finally not to disappoint, some of this will always be broken or incomplete. My intention for my personal site isn't to be `Prod` ready. Think of it as a playground. <a href="https://github.com/eschapp/eschappco">Pull requests always welcome for typos and more.</a>
              </h2>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
};